import { useState, useCallback, useEffect,useMemo  } from 'react';
import { wktToGeoJSON } from "@terraformer/wkt";
import axios from 'axios';
import {MVTLayer} from '@deck.gl/geo-layers';
import { GoogleMapsOverlay } from "@deck.gl/google-maps";
import {TwitterTweetEmbed} from 'react-twitter-embed';
import React from 'react';

const FloodMapLogic = (props) => {


  const [map, setMap] = useState(null);
  const [open,setOpen] = React.useState(true);
  const handleClose = () => {setOpen(false)};
  const [imageLocation,setImageLocation] = useState(null);
  const [imagePath,setImagePath] = useState(null);
  const [link,setLink] = useState(null);
  const [dpLine,setdataLine] = useState(null);
  const [selectedSource,setSelectedSource] = useState('All');
  
  const [iFrameIsOpen,setiFrameIsOpen] = useState(false);
  const [events,setEvents] = useState();
  const [selectedEvent,setSelectedEvent] = useState();
  const [noverlay,setnOverlay] = useState(null);
  const [infowindow, setInfowindow] = useState(null);
  const [iFramewindow, setiFramewindow] = useState(null);
  const [isInfowindowOpen, setIsInfowindowOpen] = useState(false);
  

  const ogCenter = {
    lat: props.coordinates.lat+0.0015,
    lng: props.coordinates.lng
  };
  const [center,setCenter] = useState(ogCenter);


  // icons for data points
  const text_dot_colors = {'twitter':'https://terracover.ai/flood-history/twitter.png','news':'https://terracover.ai/flood-history/news.png','weather':'red','japan':'yellow'};
  console.log(text_dot_colors)
  

  const onInfowindowLoad = (infowindow) => {
    // infowindow.setZIndex(100) // it is not working right now
    setInfowindow(infowindow);
    // props.setExpanded(false)
  };

  const oniFrameWindowLoad = (infowindow) => {

    setiFramewindow(infowindow);
  };

  // callbacks
  const onLoad = useCallback(function callback(map) {
  setMap(map);

  // will be removed in next update
  map.data.addListener('touchstart', function(event) {
    
    var feat = event.feature;
    var html = feat.getProperty('source');
    var dataLink = feat.getProperty('link');
    var dataLine = feat.getProperty('line');
    
    setImageLocation(event.latLng);
    setImagePath(html);
    setLink(dataLink);
    setdataLine(dataLine);

    if (html==='twitter')
    {
        setIsInfowindowOpen(false);
        
        setiFrameIsOpen(true);}
    else if (html==='news')
    {
        setiFrameIsOpen(false);
        
        setIsInfowindowOpen(true);
    }
    else
    {
      setiFrameIsOpen(false);
      setIsInfowindowOpen(false);
      
    }
    setCenter(map.getCenter());
  });


  map.data.addListener('click', function(event) {
    
    var feat = event.feature;
    var html = feat.getProperty('source');
    var dataLink = feat.getProperty('link');
    var dataLine = feat.getProperty('line');
    
    setImageLocation(event.latLng);
    setImagePath(html);
    setdataLine(dataLine);

    if (html==='twitter')
    {
      var dataLinkId = dataLink.split('/')
      setLink(dataLinkId[dataLinkId.length-1])
      
      
      setIsInfowindowOpen(false);
      setiFrameIsOpen(true);
    }
      
    else if (html==='news')
    {
        setLink(dataLink);

        setiFrameIsOpen(false);
        
        setIsInfowindowOpen(true);
    }

    else
    {
        setLink(dataLink);

        setiFrameIsOpen(false);
        setIsInfowindowOpen(false);
        
    }


    setCenter(map.getCenter());
  });


  // loading flood maps
  axios.get(`https://website-267617.uw.r.appspot.com/get_flood_maps_summary?lat=${props.coordinates.lat}&long=${props.coordinates.lng}&dist=0.1`)
  .then(
    async (res)=>{

        // TODO: make this also a query call
        const event_mvts = {
          'Imelda - 2019':'https://tiles.arcgis.com/tiles/nLl0k0Mja5hnSeSl/arcgis/rest/services/TropicalStormImelda2019_Inundation/VectorTileServer/tile/{z}/{y}/{x}.pbf',
          'Harvey - 2017':'https://tiles.arcgis.com/tiles/nLl0k0Mja5hnSeSl/arcgis/rest/services/HurricaneHarvey2017_Inundation/VectorTileServer/tile/{z}/{y}/{x}.pbf',
          'Memorial Day - 2016':'https://tiles.arcgis.com/tiles/nLl0k0Mja5hnSeSl/arcgis/rest/services/MemorialDay2016_Inundation/VectorTileServer/tile/{z}/{y}/{x}.pbf',
          'Memorial Day - 2015':'https://tiles.arcgis.com/tiles/nLl0k0Mja5hnSeSl/arcgis/rest/services/MemorialDay2015_Inundation/VectorTileServer/tile/{z}/{y}/{x}.pbf',
          'Tax Day - 2015':'https://tiles.arcgis.com/tiles/nLl0k0Mja5hnSeSl/arcgis/rest/services/TaxDay2015_Inundation/VectorTileServer/tile/{z}/{y}/{x}.pbf',

          // 'harvey':'https://api.maptiler.com/tiles/9350e180-3b6b-45b6-bcad-049f2502cc21/{z}/{x}/{y}.pbf?key=XaBAsjEWWazZbBsX9LLx',
          // 'imelda':'https://api.maptiler.com/tiles/a38dd1d7-aab8-4388-97c9-bf63a659705c/{z}/{x}/{y}.pbf?key=XaBAsjEWWazZbBsX9LLx',
          
          
        }
        
        // prepare list for UI table
        const dummyData = []
        for (var i = 0; i < res.data.length; i++) { 
          var cur_event = res.data[i]['ename']
          var cur_tuple = {label:cur_event,value:event_mvts[cur_event]};
          dummyData.push(cur_tuple)

        }
        setEvents(dummyData)

        // TODO: automatically identify which event to show as default
        setSelectedEvent(dummyData[0])
    }
  )
  .catch((err) => console.log(err))

  // add data points 
  axios.get(`https://website-267617.uw.r.appspot.com/get_data_points?lat=${props.coordinates.lat}&long=${props.coordinates.lng}&dist=0.1`)
    .then(
      (res)=>{
          

          res.data.forEach(element => {
            var scope_feature = {
              type: 'Feature',
              geometry: wktToGeoJSON(element.st_astext), // pass parsed GEOJSON here
              properties: {source:element.source, link:element.link, line:element.line}
            }
            
            

            map.data.addGeoJson(scope_feature);
            
          });

          map.data.setStyle(function(feature) {
            var sourceName = feature.getProperty('source');
            return {
              icon: {url: text_dot_colors[sourceName]},visible: true,clickable: true};
          });

      }
    )
    .catch((err) => console.log(err))
  }, [props.coordinates.lat,props.coordinates.lng]);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

 
  // to change flood maps based on selection
  useEffect(() => {
    if(selectedEvent){
      if (noverlay){
        noverlay.setMap(null)
      }
          
    var mvtLayer = new MVTLayer({
      data: selectedEvent.value,
      minZoom: 0,
      maxZoom: 20,
      getLineWidth: 0,
      getFillColor: [0,30,220,255],
      lineWidthMinPixels: 0,
      opacity:0.4,
      wireframe: true,
      onError: (error) => {
        console.error('Error loading MVT data', error);},
    });

    const temp = new GoogleMapsOverlay({
      layers: [mvtLayer],
    });
    temp.setMap(map);
    setnOverlay(temp)
  }
  },[selectedEvent])


  const selectLatestTweet = useMemo(() => {
    return <div id="tweet-style"><TwitterTweetEmbed  key={`${link}`} tweetId={`${link}`} placeholder="Loading"/> </div>;
},[link]);
  
  const markerPoint = {
    lat: props.coordinates.lat,
    lng: props.coordinates.lng
  }

  return({selectedEvent,setSelectedEvent,events,map,selectedSource,imageLocation,imagePath,link,dpLine,iFrameIsOpen,markerPoint,center,setSelectedSource,setiFrameIsOpen,onLoad,onUnmount,isInfowindowOpen,setIsInfowindowOpen,onInfowindowLoad,oniFrameWindowLoad,selectLatestTweet,open,handleClose})
}

export default FloodMapLogic;